import React, {
  useState,
  useEffect,
  useContext,
  useRef,
  createContext,
} from 'react';

import {Text} from 'react-native';

import {NavigationContainer, Theme} from '@react-navigation/native';

import RootStackNav from './nav';

import {GestureHandlerRootView} from 'react-native-gesture-handler';
import {linking} from '../routes/routes';
import {MD3DarkTheme} from 'react-native-paper';

const AppComponent = () => {
  return (
    <GestureHandlerRootView style={{width: '100%', height: '100%'}}>
      <NavigationContainer
        // onStateChange={(state)=>console.info('state change', state)}
        theme={MD3DarkTheme as any}
        linking={linking}
        fallback={<Text>Loading...</Text>}>
        <RootStackNav />
      </NavigationContainer>
    </GestureHandlerRootView>
  );
};

export default AppComponent;
